import React, { Component } from 'react';
import ParameterErrors from '../errors/ParameterErrors';
import TabInfo from '../ui_core/TabInfo';
import ImageCarousel from './ImageCarousel';
import JumpableZoomableDragable from './JumpableZoomableDragable';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
const {throwNotProvided}=ParameterErrors;
export default class PlotMoreInformationFloorPlans extends Component {
	static get _IMAGE_CAROUSEL_ASPECT_RATIO_THRESHOLD(){
		return 1.5;
	}
	constructor(props){
		super(props);
		const {getViewPort, onExpandImage, configuration}=props;
		this._configuration = configuration;
		this._callbackExpandImage = onExpandImage;
		this._getContainerViewPort = getViewPort;
		this._element = React.createRef();
		this._tabInfo = new TabInfo({title:'Floor plans', className:'floor-plans-tab'});
		this.state={site:null, plot:null, images:null};
	}
	get tabInfo(){
		return this._tabInfo;
	}
	load(site, plot){
		this.setState({site:site, plot:plot});
		this._loadFloorPlanImages(site, plot);
	}
	_loadFloorPlanImages(site, plot){
		this.setState({images:plot.floorPlanImages});
	}
	render(){
		const rootUrl = Urls.getAssetsForSite(this._configuration.siteSlug);
		 return this._configuration.scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages
		?(<ImageCarousel className="plot-more-information-floor-plans" onExpandImage={this._callbackExpandImage} images={this.state.images}
			rootUrl={rootUrl}
			aspectRatioThreshold ={PlotMoreInformationFloorPlans._IMAGE_CAROUSEL_ASPECT_RATIO_THRESHOLD} 
			getContainerViewPort={this._getContainerViewPort} ref={this._element}>
		</ImageCarousel>)
		:(<JumpableZoomableDragable className="plot-more-information-floor-plans"
			images={this.state.images} rootUrl={rootUrl}
			zoomMin={1} zoomMax={4} ref={this._element}>
		</JumpableZoomableDragable>
		);
	}
}
